module.exports = __webpack_public_path__ + "img/parsian.ec12f2b6.png";